module.exports = __webpack_public_path__ + "static/media/5_8.2f95bade.png";